import React from 'react';
import { BankSearchWeights } from '../../../../utils/types/candi_bank_types';

export interface WeightSlidersProps {
  weights: BankSearchWeights;
  override: Partial<BankSearchWeights> | null;
  onOverrideChange: (override: Partial<BankSearchWeights>) => void;
  onCommit: () => void;
  onReset: () => void;
}

export const WeightSliders: React.FC<WeightSlidersProps> = ({
  weights,
  override,
  onOverrideChange,
  onCommit,
  onReset,
}) => {
  const currentWeights = { ...weights, ...(override || {}) };
  const hasOverride = override !== null && Object.keys(override).length > 0;

  const handleSliderChange = (field: keyof BankSearchWeights, value: string) => {
    const numValue = parseFloat(value);
    onOverrideChange({ ...(override || {}), [field]: numValue });
  };

  const renderSlider = (field: keyof BankSearchWeights, label: string) => {
    const val = currentWeights[field] ?? 0;
    const percentage = Math.round(val * 100);

    return (
      <div className='flex items-center gap-3' key={field}>
        <div className='w-32 text-xs font-semibold text-slate-700 truncate'>{label}</div>
        <input
          type='range'
          min='0'
          max='1'
          step='0.05'
          value={val}
          onChange={(e) => handleSliderChange(field, e.target.value)}
          className='flex-1 accent-indigo-600 h-1.5 bg-slate-200 rounded-lg appearance-none cursor-pointer'
        />
        <div className='w-9 text-right text-xs font-bold text-slate-600 font-mono'>{percentage}%</div>
      </div>
    );
  };

  return (
    <div className='w-full space-y-2.5'>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2.5'>
        {renderSlider('semantic', 'Semantic Similarity')}
        {renderSlider('mandatorySkills', 'Important Skills')}
        {renderSlider('desirableSkills', 'Nice-to-Have Skills')}
        {renderSlider('experience', 'Experience')}
      </div>

      {hasOverride && (
        <div className='flex justify-end items-center gap-2 pt-2 border-t border-slate-200/60'>
          <span className='text-[11px] font-medium text-amber-700 bg-amber-50 px-2 py-0.5 rounded border border-amber-200'>
            Unsaved preview
          </span>
          <button
            type='button'
            onClick={onReset}
            className='px-3 py-1 text-xs font-bold text-slate-600 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors shadow-2xs'
          >
            Reset
          </button>
          <button
            type='button'
            onClick={onCommit}
            className='px-3.5 py-1 text-xs font-bold text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors shadow-sm'
          >
            Save Weights
          </button>
        </div>
      )}
    </div>
  );
};
